import React, { useEffect, useState } from "react";
import { Link, useLocation, NavLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

import { useStoreState, APP_STORE_ACTION, useStoreDispatch } from '../../common/storeContext'
import { GLOBAL_BUCKET, TENANT_NAME, BOTTOM_MENU_DATA, TENANT_BUCKET } from '../../common/constants'
import { useMiddletier } from "../../common/middletier";
import { SOCIAL_MEDIA_DATA } from '../../common/constants';
import "./template_01.css";

const Footer_01 = (props) => {
  const appState = useStoreState()
  const [show, toggleShow] = React.useState(false);
  const [expanded, setExpanded] = useState(false);
  const { t, i18n } = useTranslation();
  const { queries } = useMiddletier();
  const [socialMedia, setSocialMedia] = useState([])
  const [paymentMethod, setPaymentMethod] = useState([])
  const [license, setLicense] = useState([])
  const [certificate, setCertificate] = useState([])
  const [responsibleGaming, setResponsibleGaming] = useState([])
  const [security, setSecurity] = useState([])
  const [help, setHelp] = useState([])
  const [gameProviders, setGameProviders] = useState([])
  const appDispatch = useStoreDispatch()



  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 992px)'
  })
  const location = useLocation();

  const isProfilePage = location.pathname === '/my-profile';

  const openChat = () => {
    if (window.LC_API && typeof window.LC_API.open_chat_window === 'function') {
      const event = new Event('openChat');
      window.dispatchEvent(event);
    }
  };

  const CheckTranslate = ({k}) => {
    // const { t, i18n } = useTranslation();
    // console.log('key',k)
    return i18n.exists(k) ? <div className="footer_img_content">{t(k)}</div> : null;
  }

  useEffect(() => {

    queries([{
      index: 'getSocialMedia',
      method: 'getSocialMedia',
      params: [],
      attributes: []
    },
    {
      index: 'getPaymentMethods',
      method: 'getPaymentMethods',
      params: [],
      attributes: []
    }, {
      index: 'getLicense',
      method: 'getLicense',
      params: [{ code: 'filter', graphqlType: 'JSON', required: true, value: { where: { status: 'ACTIVE' } } },],
      attributes: ['code', 'url']
    }, {
      index: 'getCertificate',
      method: 'getCertificate',
      params: [{ code: 'filter', graphqlType: 'JSON', required: true, value: { where: { status: 'ACTIVE' } } },],
      attributes: ['code', 'url']
    }, {
      index: 'getResponsibleGaming',
      method: 'getResponsibleGaming',
      params: [{ code: 'filter', graphqlType: 'JSON', required: true, value: { where: { status: 'ACTIVE' } } },],
      attributes: ['code', 'url']
    }, {
      index: 'getSecurity',
      method: 'getSecurity',
      params: [{ code: 'filter', graphqlType: 'JSON', required: true, value: { where: { status: 'ACTIVE' } } },],
      attributes: ['code', 'url']
    },
    {
      index: 'getFaq',
      method: 'getFaq',
      params: [
        { code: 'language', graphqlType: 'String', required: true, value: i18n.resolvedLanguage },
        { code: 'category', graphqlType: 'String', required: false, value: 'HELP' }
      ],
      attributes: []
    },
    {
      index: 'getGameProviders',
      method: 'getGameProviders',
      params: [
        { code: 'filter', graphqlType: 'JSON', required: true, value: { where: { '$_game_provider_game_types.status$': "ACTIVE", status: 'ACTIVE' }, order: [['index', 'ASC'], ['name', 'ASC']] } },
      ],
      attributes: ['code', 'name', ['_game_provider_game_types', ['type']]]
    },
    ])
      .then(({ data }) => {

        const getSocialMediaData = data['getSocialMedia'].map((item) => {
          const _item = SOCIAL_MEDIA_DATA[item.code];
          return { ...item, value: JSON.parse(item.value), category: _item ? _item.category : null, icon: _item ? _item.icon : null };
        }).filter((item) => item.category === 'socialMedia' && item.value['url'] !== "");

        // SORT SOCIAL MEDIA
        const sortedSocialMediaData = appState?.socialMediaIndex?.map(code => getSocialMediaData?.find(item => item.code === code))?.filter(Boolean).concat(getSocialMediaData?.filter(d => !appState?.socialMediaIndex.includes(d.code)));

        setSocialMedia(sortedSocialMediaData)
        setPaymentMethod(data['getPaymentMethods'])
        setLicense(data['getLicense'])
        setCertificate(data['getCertificate'])
        setResponsibleGaming(data['getResponsibleGaming'])
        setSecurity(data['getSecurity'])
        setHelp(data['getFaq'])
        setGameProviders(data['getGameProviders'])
        // console.log('hihi: ', getSocialMediaData)

      }).catch((error) => {
        console.log('error: ', error)
      })

  }, [queries, i18n.resolvedLanguage, appState?.socialMediaIndex]);

  const { desktopToggle, mobileToggle, game_licenseToggle, certificationToggle, payment_methodToggle, suggested_browserToggle, follow_usToggle, responsible_gamingToggle, securityToggle, footer_titleToggle_desktop, footer_titleToggle_mobile, footer_infoToggle, position, bottomMenuToggle, gameProvidersToggle, providerRowDesktop, providerRowMobile, shareHolderToggle, infoPosition, folderImage } = props;
  const widthColumn = isDesktopOrLaptop ? (providerRowDesktop ? 100 / providerRowDesktop : 0) : (providerRowMobile ? 100 / providerRowMobile : 0)


  if (((desktopToggle || mobileToggle) === true) && !isProfilePage) {
    return (
      <>

        <footer className={`section ${desktopToggle ? "" : "d-lg-none"} ${mobileToggle ? "" : "d-none d-lg-block"} ${(!isDesktopOrLaptop && appState.loggedIn && bottomMenuToggle) && 'bottomMenuFooter'}`} id="footer_01">
          <div className="footer font_h4 color_footer">
            <div className={` footer_container ${position === 'horizontal' ? 'footer_container_horizontal container-lg' : ''}`}>
              <div className={`footer_row 2 footer_menu_container ${footer_titleToggle_desktop ? "" : "d-lg-none"} ${footer_titleToggle_mobile ? (isDesktopOrLaptop ? "" : "footer_title_m") : "d-none d-lg-block"}`}>
                <div className="container-lg footer_menu_wrap">
                  {isDesktopOrLaptop ? <div className="font_h5 footer_help">
                    {help?.map((item, index) => {
                      return (
                        <div key={index}>
                          <Link to={`/help#${item?.faq}`} >{item.title}</Link>{position !== 'horizontal' && (<>︙</>)}
                        </div>
                      );
                    })}
                    <div><Link to="/contact-us" >{t('contact_us')}</Link>{position !== 'horizontal' && (<>︙</>)}</div>
                  </div> : <>
                    {help.length > 0 && (<details>
                      <summary className="footer_info_summary">
                        <div className="footer_info_text">{t('help')}</div>
                      </summary>
                      <div className="footer_info_selection">
                        {help?.map((item, index) => {
                          return (
                            <div key={index}>
                              <Link to={`/help#${item?.faq}`} >{item.title}</Link>
                            </div>
                          );
                        })}
                      </div>
                    </details>)}
                    <div className="footer_info_text">
                      <Link to="/contact-us" >{t('contact_us')}</Link>
                    </div>
                  </>}

                </div>
              </div>
              <div className={`${position === 'horizontal' ? 'footer_info_container_wrap' : 'container-lg'}`}>
                <div className={`footer_info_container footer_info_${infoPosition ?? 'center'}`}>
                  {footer_infoToggle && <div className="row footer_row 3 footer_seo_wrap">
                    <div className="seo_footer_container">
                      {!show && <div className="text-uppercase m-0 seo_footer_title">{t('footer_title')}</div>}
                      <div className="font_h5 seo_footer_content">
                        {!show && t('footer_details')}
                        <span onClick={() => toggleShow(!show)}> {show ? t('hide_info') : t('read_more')}</span>
                        {show && (<div className="footer_seo_all">
                          <div className="footer_seo_all_col">
                            <div className="footer_seo__title">
                              {t('footer_details_title_01')}
                            </div>
                            <div className="footer_seo_details">
                              {t('footer_details_content_01')}
                            </div>
                            <div className="footer_seo__title">
                              {t('footer_details_title_02')}
                            </div>
                            <div className="footer_seo_details">
                              {t('footer_details_content_02')}
                            </div>
                          </div>
                          <div className="footer_seo_all_col">
                            <div className="footer_seo__title">
                              {t('footer_details_title_03')}
                            </div>
                            <div className="footer_seo_details">
                              {t('footer_details_content_03')}
                            </div>
                            <div className="footer_seo__title">
                              {t('footer_details_title_04')}
                            </div>
                            <div className="footer_seo_details">
                              {t('footer_details_content_04')}
                            </div>
                          </div>
                        </div>)
                        }
                      </div>
                    </div>
                    <div>


                    </div>


                  </div>}
                  {gameProvidersToggle && <div className="row footer_row footer_gameProviders_wrap">
                    {gameProviders?.map((item, index) => {
                      return (
                        <div key={`${item.code}_${index}`} style={{ width: widthColumn + '%' }}>
                          <img src={`${folderImage === 'footer' ? `${TENANT_BUCKET}/footer/game_provider` : `${GLOBAL_BUCKET}/game_provider_logo`}/1x1/${item.code}.png`} alt={`${item.code}`} />
                        </div>

                      );
                    })}
                    <CheckTranslate key={'gameProvider_footer_content'}/>
                  </div>}
                  <div className="row footer_row footer_licenses_wrap">
                    {game_licenseToggle &&
                      <div className="footer_info footer_gaming_license">
                        <div className="footer_title">{t('gaming_license')}</div>
                        <ul className="footer_info_img">
                          {license?.map(function (item, index) {
                            if (item?.url) {
                              return (

                                <Link to={`${item?.url}`} target="_blank">
                                  <li key={item.code}>
                                    <img src={`${folderImage === 'footer' ? `${TENANT_BUCKET}/footer` : `${GLOBAL_BUCKET}`}/gaming_license/${item.code}.png`} alt="footer license" />
                                  </li>
                                </Link>
                              )
                            } else {
                              return (
                                <li key={item.code}>
                                  <img src={`${folderImage === 'footer' ? `${TENANT_BUCKET}/footer` : `${GLOBAL_BUCKET}`}/gaming_license/${item.code}.png`} alt="footer license" />
                                </li>
                              )
                            }

                          })}
                          {/* <li>
                        <img src={`${GLOBAL_BUCKET}/gaming_license/PAGCOR.png`} alt="footer license" />
                      </li> */}
                        </ul>
                        <CheckTranslate k={'gamingLicense_footer_content'}/>
                      </div>}

                    {certificationToggle && <div className="footer_info">
                      <div className="footer_title">{t('certification')}</div>
                      <ul className="footer_info_img">
                        {certificate?.map(function (item, index) {
                          if (item?.url) {
                            return (

                              <Link to={`${item?.url}`} target="_blank">
                                <li key={item.code}>
                                  <img src={`${folderImage === 'footer' ? `${TENANT_BUCKET}/footer` : `${GLOBAL_BUCKET}`}/certifications/${item.code}.png`} alt="footer certifications" />
                                </li>
                              </Link>
                            )
                          } else {
                            return (
                              <li key={item.code}>
                                <img src={`${folderImage === 'footer' ? `${TENANT_BUCKET}/footer` : `${GLOBAL_BUCKET}`}/certifications/${item.code}.png`} alt="footer certifications" />
                              </li>
                            )
                          }

                        })}

                      </ul>
                      <CheckTranslate k={'certification_footer_content'}/>
                    </div>}



                    {payment_methodToggle && <div className="footer_info footer_payment_method">
                      <div className="footer_title">{t('payment_methods')}</div>
                      <ul className="footer_info_img">
                        <li>
                          <img src={`${folderImage === 'footer' ? `${TENANT_BUCKET}/footer` : `${GLOBAL_BUCKET}`}/payment/BANKTRANSFER.png`} alt="footer payment method" />
                        </li>
                        {paymentMethod.map(function (item, index) {
                          return (
                            <li key={item.code}>
                              <img src={`${folderImage === 'footer' ? `${TENANT_BUCKET}/footer` : `${GLOBAL_BUCKET}`}/payment/${item.code}.png`} alt="" />
                            </li>
                          )
                        })}
                        {/* <li>
                    <img src={`${GLOBAL_BUCKET}/payment/ipay4u.png`} alt="footer payment method" />
                  </li>
                  <li>
                    <img src={`${GLOBAL_BUCKET}/payment/duitnow.png`} alt="footer payment method" />
                  </li>
                  <li>
                    <img src={`${GLOBAL_BUCKET}/payment/tng.png`} alt="footer payment method" />
                  </li>
                  <li>
                    <img src={`${GLOBAL_BUCKET}/payment/grabpay.png`} alt="footer payment method" />
                  </li>
                  <li>
                    <img src={`${GLOBAL_BUCKET}/payment/boost.png`} alt="footer payment method" />
                  </li>
                  <li>
                    <img src={`${GLOBAL_BUCKET}/payment/shopeepay.png`} alt="footer payment method" />
                  </li> */}
                      </ul>
                      <CheckTranslate k={'paymentMethod_footer_content'}/>
                    </div>}

                    {suggested_browserToggle && <div className="footer_info">
                      <div className="footer_title">{t('suggested_browser')}</div>
                      <ul className="footer_info_img">
                        <li>
                          <img src={`${folderImage === 'footer' ? `${TENANT_BUCKET}/footer` : `${GLOBAL_BUCKET}`}/browser/chrome.png`} alt="footer suggested browser" />
                        </li>
                        <li>
                          <img src={`${folderImage === 'footer' ? `${TENANT_BUCKET}/footer` : `${GLOBAL_BUCKET}`}/browser/firefox.png`} alt="footer suggested browser" />
                        </li>
                      </ul>
                      <CheckTranslate k={'suggestedBrowser_footer_content'}/>

                    </div>}



                    {(follow_usToggle && socialMedia?.length > 0) && <div className="footer_info footer_follow_us">
                      <div className="footer_title">{t('follow_us')}</div>
                      <ul className="footer_info_img">
                        {socialMedia.map(function (item, index) {
                          return (
                            <li key={item.code}>
                              <a href={item.value['url'] === "" ? "#" : item.value['url']} onClick={(e) => {
                                if (item.value['url'] === "") {
                                  e.preventDefault();
                                }
                              }} target="_blank" rel="noopener noreferrer"> <img src={`${folderImage === 'footer' ? `${TENANT_BUCKET}/footer` : `${GLOBAL_BUCKET}`}/social/${item.icon}.png`} alt={item.name} /></a>
                            </li>
                          )
                        })}
                        {/* <li>
                    <img src={`${GLOBAL_BUCKET}/social/facebook.png`} alt="footer follow us" />
                  </li>
                  <li>
                    <img src={`${GLOBAL_BUCKET}/social/instagram.png`} alt="footer follow us" />
                  </li>
                  <li>
                    <img src={`${GLOBAL_BUCKET}/social/twitter.png`} alt="footer follow us" />
                  </li>
                  <li>
                    <img src={`${GLOBAL_BUCKET}/social/youtube.png`} alt="footer follow us" />
                  </li>
                  <li>
                    <img src={`${GLOBAL_BUCKET}/social/tiktok.png`} alt="footer follow us" />
                  </li> */}
                      </ul>
                      <CheckTranslate k={'followUs_footer_content'}/>

                    </div>}

                    {responsible_gamingToggle && <div className="footer_info">
                      <div className="footer_title">{t('responsible_gaming')}</div>
                      <ul className="footer_info_img">
                        {responsibleGaming?.map(function (item, index) {
                          if (item?.url) {
                            return (

                              <Link to={`${item?.url}`} target="_blank">
                                <li key={item.code}>
                                  <img src={`${folderImage === 'footer' ? `${TENANT_BUCKET}/footer` : `${GLOBAL_BUCKET}`}/responsible_gaming/${item.code}.png`} alt="footer license" />
                                </li>
                              </Link>
                            )
                          } else {
                            return (
                              <li key={item.code}>
                                <img src={`${folderImage === 'footer' ? `${TENANT_BUCKET}/footer` : `${GLOBAL_BUCKET}`}/responsible_gaming/${item.code}.png`} alt="footer license" />
                              </li>
                            )
                          }

                        })}
                      </ul>
                      <CheckTranslate k={'responsibleGaming_footer_content'}/>
                    </div>
                    }

                    {securityToggle && <div className="footer_info">
                      <div className="footer_title">{t('security')}</div>
                      <ul className="footer_info_img">
                        {security?.map(function (item, index) {
                          if (item?.url) {
                            return (

                              <Link to={`${item?.url}`} target="_blank">
                                <li key={item.code}>
                                  <img src={`${folderImage === 'footer' ? `${TENANT_BUCKET}/footer` : `${GLOBAL_BUCKET}`}/security/${item.code}.png`} alt="footer security" />
                                </li>
                              </Link>
                            )
                          } else {
                            return (
                              <li key={item.code}>
                                <img src={`${folderImage === 'footer' ? `${TENANT_BUCKET}/footer` : `${GLOBAL_BUCKET}`}/security/${item.code}.png`} alt="footer security" />
                              </li>
                            )
                          }

                        })}
                      </ul>
                      <CheckTranslate k={'security_footer_content'}/>
                    </div>
                    }


                    {shareHolderToggle && <div className="footer_info">
                      <Link to={`/`}><div className="footer_title">{t('shareholder')}</div></Link>
                      {/* <ul className="footer_info_img">
                        <li>
                          <img src={`${GLOBAL_BUCKET}/responsible_gaming/18+.png`} alt="footer responsible gaming" />
                        </li>
                        <li>
                          <img src={`${GLOBAL_BUCKET}/responsible_gaming/begambleaware.png`} alt="footer responsible gaming" />
                        </li>
                        <li>
                          <img src={`${GLOBAL_BUCKET}/responsible_gaming/gamcare.png`} alt="footer responsible gaming" />
                        </li>
                      </ul> */}
                    </div>
                    }
                      <CheckTranslate k={'shareholder_footer_content'}/>
                  </div>

                </div>
              </div>
              
              {/* <div className={`footer_row 2 footer_menu_container ${footer_titleToggle_desktop ? "" : "d-lg-none"} ${footer_titleToggle_mobile ? (isDesktopOrLaptop ? "" : "footer_title_m") : "d-none d-lg-block"}`}>
               */}
               <div className="footer_row footer_menu_container footer-seo-content">
                <div className="container-lg footer-seo-content">
                  <div className={`content-wrapper ${expanded ? 'expanded' : ''}`}>

                    <h1>WIN22 Official Website 2026 – Trusted Online Casino Malaysia</h1>

                    <p><a href="https://win22.info/">WIN22</a> has emerged as one of Malaysia's most trusted online casino platforms, built on a foundation of security, game diversity, and a genuinely player-focused experience. The Malaysian online gambling industry has evolved significantly over the past decade, driven by technological advancements and increasing demand for accessible digital entertainment. Among the platforms that have risen to prominence, WIN22 stands out as a name that consistently delivers on its promises. Established with a commitment to transparency and quality, the platform has earned the loyalty of thousands of players across Malaysia and Southeast Asia.</p>

                    <p>What sets this platform apart from dozens of competitors is not just the volume of games offered, but the underlying infrastructure — from encrypted payment gateways to partnerships with globally recognised game providers. In 2026, WIN22 continues to raise the bar in an industry where trust is everything.</p>

                    <h2>WIN22 Online Casino Games</h2>

                    <p>Online casino gaming has become one of the most popular forms of digital entertainment in Malaysia, and the selection available at WIN22 reflects the full spectrum of what modern players expect. The live casino section features real-time games hosted by professional dealers, streamed in full HD from studios operated by providers such as Evolution Gaming, SA Gaming, Allbet, and Dream Gaming. Players can choose from baccarat, blackjack, roulette, sic bo, dragon tiger, and several regional variations that cater specifically to Asian preferences.</p>

                    <p>Beyond live dealer tables, WIN22 also provides a robust library of RNG-based table games for players who prefer a faster pace without waiting for other participants. These digital versions replicate the rules and odds of their live counterparts while offering autoplay features and customisable bet limits. For poker enthusiasts, the platform hosts both video poker titles and multiplayer poker rooms where skill and strategy are rewarded.</p>

                    <p>Game fairness is maintained through independent audits and certified random number generators, ensuring that every card dealt and every wheel spin produces genuinely random outcomes. This level of integrity is essential for building long-term player confidence — something that WIN22 treats as a foundational principle rather than a marketing afterthought.</p>

                    <h2>WIN22 Slot Games Malaysia</h2>

                    <p>Slot games remain the most played category across virtually every online casino platform, and the collection at WIN22 is one of the most extensive in the Malaysian market. With titles sourced from Pragmatic Play, Spadegaming, JILI, Microgaming, PG Soft, Habanero, and CQ9, players have access to hundreds of games spanning every theme and mechanic imaginable — from ancient mythology and underwater adventures to fruit machines and blockbuster-inspired video slots.</p>

                    <p>What matters to experienced slot players goes beyond aesthetics. Return-to-player (RTP) percentages, volatility levels, and bonus feature frequency are the real metrics that determine a game's value. WIN22 provides detailed game information so that players can make informed choices. High-volatility slots like Gates of Olympus and Starlight Princess attract risk-tolerant players chasing massive multipliers, while low-volatility options offer steadier payouts suited to longer sessions with smaller bankrolls.</p>

                    <p>Progressive jackpot slots deserve special mention. These games pool a fraction of every bet placed across the network into a cumulative prize that can reach life-changing sums. The platform regularly features jackpot titles from Mega Moolah to local favourites, giving Malaysian players a legitimate shot at extraordinary payouts without requiring high-stakes wagers.</p>

                    <p>New titles are added to the library on a weekly basis, reflecting the fast production cycles of modern game studios. This constant refreshment keeps the experience engaging for long-term members who might otherwise grow tired of a static catalogue.</p>

                    <h2>WIN22 Sports Betting Platform</h2>

                    <p>Sports betting is deeply embedded in Malaysian culture, with football being the dominant discipline. The sportsbook at <a href="https://win22.info/">WIN22</a> covers the English Premier League, La Liga, Serie A, Bundesliga, UEFA Champions League, and virtually every top-tier football competition globally. Beyond football, the platform extends its coverage to basketball (NBA, EuroLeague), tennis (ATP, WTA, Grand Slams), badminton, cricket, MMA, boxing, and a growing esports section that includes Dota 2, CS2, League of Legends, and Mobile Legends.</p>

                    <p>What distinguishes a quality sportsbook from a mediocre one is the depth of its markets and the competitiveness of its odds. WIN22 offers an impressive variety of betting options per match — from standard 1X2 and Asian handicap lines to correct score, total goals, both teams to score, first goalscorer, half-time results, and numerous prop bets. Live in-play betting allows punters to place wagers as the action unfolds, with odds updating in real time based on match developments.</p>

                    <p>For more analytical bettors, the platform provides match statistics, head-to-head records, and form guides that support data-driven decision-making. This combination of comprehensive coverage, competitive pricing, and analytical tools makes WIN22 a serious option for both recreational and semi-professional bettors.</p>

                    <h2>Why Choose WIN22 in 2026</h2>

                    <p>The online casino market in Malaysia is crowded, and players are right to be cautious about where they invest their money and personal data. Choosing the wrong platform can mean delayed withdrawals, rigged games, unresponsive customer service, or worse — losing funds entirely to a fraudulent operator. WIN22 has built its reputation specifically by addressing these concerns head-on.</p>

                    <p>Security is the foundation. The platform employs 256-bit SSL encryption across all transactions and data transfers, the same standard used by major financial institutions worldwide. Player accounts are protected by two-factor authentication, and sensitive information is stored on segregated servers with strict access protocols. These are not optional extras — they are the minimum requirements that any legitimate platform must meet, and <a href="https://win22.info/">WIN22</a> exceeds them.</p>

                    <p>Customer support operates 24 hours a day, 7 days a week, through live chat, WhatsApp, and Telegram. Response times are consistently under two minutes during peak hours — a benchmark that many competitors fail to achieve. The support team is trained to handle account queries, technical issues, payment processing, and responsible gambling inquiries with equal proficiency.</p>

                    <p>Promotions and bonuses are where WIN22 truly differentiates itself from the competition. Rather than offering a single generic welcome deal, the platform maintains a deep portfolio of promotions that cover every player type, game category, and stage of membership. Here is a breakdown of the current bonus structure available in 2026:</p>

                    <h3>Welcome Bonuses</h3>

                    <p>New members are greeted with some of the most competitive sign-up offers in the Malaysian market. The headline offer is a <strong>222% Welcome Bonus</strong> for slot players — a multiplier that significantly exceeds the industry standard of 100–150%. For those who prefer table games, a <strong>55% Live Casino Welcome Bonus</strong> provides up to MYR 200 in bonus funds on the first deposit. Sports bettors are not left out either, with a <strong>100% Sports Free First Bet</strong> that delivers full cashback up to RM100 if the first wager results in a loss. This risk-free entry point removes the anxiety many new bettors feel when placing their first real-money wager.</p>

                    <p>Additionally, the <strong>20% Slot Welcome Bonus</strong> offers a more conservative but still valuable boost for players who prefer lower turnover requirements attached to their bonus funds.</p>

                    <h3>Daily and Reload Bonuses</h3>

                    <p>WIN22 understands that player retention depends on consistent value, not just a strong first impression. The <strong>20% Daily First Deposit</strong> bonus rewards players every single day on their first transaction — a recurring benefit that compounds over time and effectively reduces the house edge for regular players. For slot enthusiasts who top up frequently, the <strong>7% Slot Unlimited Reload Bonus</strong> adds extra value to every deposit with no cap on the number of claims per day.</p>

                    <p>Night owls benefit from the <strong>Midnight Topup Bonus</strong>, a time-limited promotion that rewards deposits made during late-night hours. This kind of targeted incentive shows a level of promotional sophistication that most competitors simply do not offer.</p>

                    <h3>Free Spins and Exclusive Slot Promotions</h3>

                    <p>The <strong>188 Free Spin Frenzy</strong> gives slot players a substantial number of complimentary spins, allowing them to explore new titles or chase jackpots without dipping into their own balance. The <strong>PP Share & Win</strong> promotion, run in collaboration with Pragmatic Play, adds a social element by rewarding players who engage with the community. For dedicated slot players, the <strong>Slot Advantage Package</strong> bundles multiple benefits into a single offer — combining deposit bonuses, free spins, and cashback into an irresistible package designed for high-frequency play.</p>

                    <h3>Cashback, Rebate, and Rescue Bonuses</h3>

                    <p>Losing sessions are an inevitable part of gambling, and WIN22 provides multiple safety nets to soften the blow. The <strong>Daily Rescue Bonus</strong> offers up to MYR 900 in recovery funds for players who experience significant losses, giving them the chance to bounce back without making additional deposits. A <strong>Daily 1% Rebate Bonus</strong> applies across slots, live casino, and sports betting — returning a percentage of total turnover regardless of win or loss outcomes.</p>

                    <p>Higher-tier members benefit from the <strong>3% Weekly Rebate up to MYR 1,500</strong>, available across slots, live casino, sports, and special VIP categories. This weekly rebate represents one of the most generous recurring cashback structures in the Malaysian online casino space. The <strong>Loyalty Cashback MYR 250</strong> adds another layer, allowing players to claim a bonus every two months simply for maintaining active membership.</p>

                    <h3>Referral, Birthday, and Monthly Rewards</h3>

                    <p>The <strong>30% Referral Bonus</strong> incentivises existing players to invite friends, rewarding both the referrer and the new member. Word-of-mouth remains the most trusted form of marketing, and WIN22 leverages this by making referrals financially worthwhile. Every member also receives a <strong>Birthday Bonus of MYR 688</strong> — a generous annual gift available across slots, live casino, and sports, exclusive to VIP and special-tier members.</p>

                    <p>The <strong>Monthly Lucky Bonus</strong> provides yet another recurring reward for active players across slot and live casino categories, ensuring that every month of continued play is acknowledged and compensated.</p>

                    <h3>Platform Strengths at a Glance</h3>

                    <ul>
                        <li>Licensed operation with verified game fairness and independent auditing</li>
                        <li>Over 1,000 games across casino, slots, sports, lottery, and fishing categories</li>
                        <li>Partnerships with 50+ globally recognised game providers</li>
                        <li>17+ active promotions covering welcome bonuses, daily rewards, cashback, rebates, and VIP perks</li>
                        <li>24/7 multilingual customer support via live chat, WhatsApp, and Telegram</li>
                        <li>256-bit SSL encryption and two-factor account authentication</li>
                        <li>Transparent bonus terms with achievable wagering requirements</li>
                        <li>Fully responsive mobile platform — no app download required</li>
                        <li>Responsible gambling tools including deposit limits and self-exclusion</li>
                    </ul>

                    <h2>How to Register WIN22 Account</h2>

                    <p>Creating an account is straightforward and takes less than three minutes. The registration process has been streamlined to remove unnecessary friction while still complying with standard identity verification requirements.</p>

                    <ol>
                        <li>Navigate to the official website at <a href="https://win22.info/">win22.info</a> using any browser on desktop or mobile.</li>
                        <li>Click the "Register" or "Sign Up" button located at the top of the page.</li>
                        <li>Enter your preferred username, a strong password, and a valid phone number. Select your preferred currency (MYR is the default for Malaysian players).</li>
                        <li>Complete the verification step. This may involve an OTP sent to your phone or email confirmation depending on the registration method chosen.</li>
                        <li>Log in to your new account and navigate to the banking section to make your first deposit.</li>
                        <li>Claim the welcome bonus available to new members and begin exploring the game library.</li>
                    </ol>

                    <p>It is worth noting that WIN22 enforces a one-account-per-person policy. Duplicate accounts created for the purpose of abusing promotional offers will be flagged and suspended. This policy protects the integrity of the platform and ensures that genuine players receive the full benefits they are entitled to.</p>

                    <h2>WIN22 Fast Deposit and Withdrawal</h2>

                    <p>Transaction speed is one of the most critical factors in a player's experience. No matter how impressive a game library is, slow or unreliable payment processing will drive players away. WIN22 has invested heavily in its payment infrastructure to ensure that deposits are credited instantly and withdrawals are processed within minutes — not hours or days.</p>

                    <p>The platform supports a wide range of payment methods tailored to the Malaysian market:</p>

                    <ul>
                        <li><strong>Online Bank Transfer</strong> — Direct transfers from major Malaysian banks including Maybank, CIMB, Public Bank, RHB, Hong Leong Bank, and AmBank. Deposits are processed instantly through secure banking integrations.</li>
                        <li><strong>E-Wallets</strong> — Touch 'n Go eWallet, GrabPay, Boost, and ShopeePay are all supported, offering convenience for players who prefer cashless digital transactions.</li>
                        <li><strong>Telco Reload</strong> — A unique option that allows deposits through prepaid mobile credit, ideal for players who value anonymity or do not have traditional banking access.</li>
                        <li><strong>Cryptocurrency</strong> — USDT (Tether) deposits and withdrawals are available for players who prefer blockchain-based transactions with enhanced privacy.</li>
                    </ul>

                    <p>Minimum deposit amounts are kept deliberately low to accommodate players at every budget level, while maximum withdrawal limits are generous enough to satisfy high-volume players. The withdrawal verification process is designed to balance speed with security — first-time withdrawals may require basic identity confirmation, but subsequent requests from verified accounts are processed automatically.</p>

                    <p>WIN22 does not charge any fees for deposits or withdrawals, a policy that further demonstrates the platform's player-first approach. Hidden transaction fees are a common complaint against lesser operators, and the absence of such charges here is a significant advantage.</p>

                    <p>For players in Malaysia seeking a reliable, secure, and feature-rich online casino platform in 2026, WIN22 represents a proven choice backed by a strong track record, diverse gaming options, and an unwavering focus on player satisfaction. Visit <a href="https://win22.info/">WIN22</a> to explore the full range of games, promotions, and services available.</p>

                  </div>
                  
                  {/* Read More Button */}
                  <button
                    className={`read-more-btn ${expanded ? 'hidden' : ''}`}
                    onClick={() => setExpanded(true)}
                  >
                    Read More
                  </button>
                </div>
              </div>
              
              <div className="row footer_row footer_copyright_container">

              
              <div className="font_h5 footer_copyright_box">
                <div className="text-center footer_copyright">
                  © 2026 Copyright: {TENANT_NAME.toUpperCase()}
                </div>
              </div>
              <div className="font_h5 footer_copyright_box footer_version_box">
                <div className="text-center footer_copyright">
                  Version: {window.BUILD_VERSION}
                </div>
              </div>


            </div>
            </div>
          </div>

        </footer>
        {(!isDesktopOrLaptop && appState.loggedIn && bottomMenuToggle) && (
          <div className="bottomNav">
            {BOTTOM_MENU_DATA?.map((item, index) => {
              if (item.name === 'live_chat') {
                return (
                  <div key={`${item.name}_${index}`} className="bottomNav_selection" onClick={() => openChat()}>
                    <img src={item.icon} alt="bottom nav icon" />
                    <span>{t(item.name)}</span>
                  </div>
                );
              } else {
                return (
                  <NavLink to={`${item.url}`} key={`${item.name}_${index}`} className="bottomNav_selection">
                    {({ isActive }) => (
                      <>
                        <img src={isActive ? item.selectedIcon : item.icon} alt="bottom nav icon" />
                        <span className={`${isActive ? 'active' : ''}`}>{t(item.name)}</span>
                      </>
                    )}
                  </NavLink>
                );
              }

            })}
          </div>
        )}
      </>
    );
  } else { }
};

export default Footer_01;
